module.exports = __webpack_public_path__ + "img/P3-scaled.3d69229d.jpg";